import { motion, useReducedMotion } from "motion/react";
import { APPLICATION_URL, curatedCopy } from "../../content";
import { Button } from "../ui/Button";

const easeOut = [0.16, 1, 0.3, 1] as const;

/** Quiet statement on curation. One column, one fade, lots of air. */
export function Curated() {
  const reduce = useReducedMotion();

  return (
    <section className="bg-paper py-28 md:py-40">
      <motion.div
        initial={reduce ? false : { opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.3 }}
        transition={{ duration: 0.7, ease: easeOut }}
        className="mx-auto w-full max-w-[40rem] px-5 md:px-10"
      >
        <h2 className="display-type text-[clamp(2rem,4vw,3.4rem)] text-ink">
          {curatedCopy.title}
        </h2>
        <div className="mt-8 space-y-4">
          {curatedCopy.body.map((line) => (
            <p key={line} className="text-lg leading-relaxed text-ink-soft">
              {line}
            </p>
          ))}
        </div>
        <Button variant="ghost" href={APPLICATION_URL} className="mt-10">
          {curatedCopy.cta}
        </Button>
      </motion.div>
    </section>
  );
}
